var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('md-toolbar',{attrs:{"md-elevation":"1"}},[_c('h3',{staticClass:"md-title",staticStyle:{"flex":"1"}},[(![
          '/trial/email',
          '/trial/apply',
          '/trial/start',
          '/contract/email',
          '/contract/verify',
          '/contract/apply',
          '/contract/preview',
          '/contract/complete'
      ].includes(_vm.$route.path))?_c('router-link',{attrs:{"to":{name: 'MapLogin'}}},[_c('img',{attrs:{"src":"https://cdn.jon-api.com/shikaku-map/img/logo.png"}})]):_c('div',[_c('img',{attrs:{"src":"https://cdn.jon-api.com/shikaku-map/img/logo.png"}})])],1),(![
                  '/terms',
                  '/legal',
                  '/payment',
                  '/trial/email',
                  '/trial/apply',
                  '/trial/start',
                  '/simulation',
                  '/contract/email',
                  '/contract/verify',
                  '/contract/apply',
                  '/contract/preview',
                  '/contract/complete',
                  '/faq'
                 ].includes(_vm.$route.path))?_c('router-link',{staticClass:"md-raised md-primary",attrs:{"to":{name: 'MapLogin'},"tag":"md-button"}},[_c('span',[_vm._v("ログイン")]),_c('md-icon',[_vm._v("arrow_right")])],1):_vm._e(),(['/simulation'].includes(_vm.$route.path))?_c('a',{attrs:{"href":"https://www.jon.co.jp/aboutus/company/","rel":"noopener","target":"_blank"}},[_c('md-button',{staticClass:"md-raised"},[_c('span',[_vm._v("企業情報")]),_c('md-icon',[_vm._v("apartment")])],1)],1):_vm._e(),(![
                  '/forgot-account',
                  '/reminder',
                  '/faq'
                 ].includes(_vm.$route.path))?_c('md-button',{staticClass:"md-raised",on:{"click":_vm.toContact}},[_c('span',[_vm._v("お問い合わせ")]),_c('md-icon',[_vm._v("arrow_right")])],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }